/**
 * Dashboard constants.
 */

export const PROJECTS_UPDATES_DASHBOARD_TEXT =
    "Updates to Projects you're working on will appear here as they happen.";

export const CREATE_OWN_PROJECT_DASHBOARD_TEXT =
    "Want to start Projects of your own?";

export const FAVORITES_UPGRADE_FREE_ACC_TEXT =
    "Upgrade to a paid account to view and save favorite products.";

export const SAVE_OWN_FAVORITES_DASHBOARD_TEXT =
    "Want to save your own favorite products?";

export const ORG_FAVORITES_DASHBOARD_TEXT =
    "Your organization's favorite products will appear here as people add them.";

export const CONTACT_ADMIN_DASHBOARD_TEXT =
    "Contact your Admin to request a Member account.";

export const CONTACT_SM_DASHBOARD_TEXT =
    "Contact Sustainable Minds to get a paid subscription.";

export const START_A_PROJECT_TEXT =
    "Start a Project to see changes appear here.";

export const LIVE_GUIDELINE_UPDATES_EMPTY_TEXT =
    "Updates to Live Guidelines will appear here as they happen.";

export const DASHBOARD_TEXT = {
    PROJECTS_UPDATES_DASHBOARD_TEXT,
    CREATE_OWN_PROJECT_DASHBOARD_TEXT,
    FAVORITES_UPGRADE_FREE_ACC_TEXT,
    SAVE_OWN_FAVORITES_DASHBOARD_TEXT,
    ORG_FAVORITES_DASHBOARD_TEXT,
    CONTACT_ADMIN_DASHBOARD_TEXT,
    CONTACT_SM_DASHBOARD_TEXT,
    START_A_PROJECT_TEXT,
    LIVE_GUIDELINE_UPDATES_EMPTY_TEXT
};
